import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const P_MODELE_IMPRESSION_SCHEMA_LITERAL = {
    title: 'Schéma Modèle Impression',
    description: 'Décrit Modèle Impression',
    version: 2,
    keyCompression: false,
    primaryKey: 'ID',
    type: 'object',
    properties: {
        ID: { type: 'string', maxLength : 36 },
        LIBELLE: { type: 'string', maxLength : 255 },
        DATE_CREATION: { type: 'string' },
        DATE_MODIFICATION: { type: ['string', 'null'] },
        DATE_SUPPRESSION: { type: ['string', 'null'] },
        SOMMEIL: { type: 'number' },
        IS_DEFAULT: { type: 'number' },
        PARAMS_MODELE: { type: 'string' },
        TYPE_MODELE_IMPRESSION: { type: 'number' },
        IMPORT_ID: { type: ['string', 'null'] },
    },
    required: [ 'ID' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(P_MODELE_IMPRESSION_SCHEMA_LITERAL);
export type RxPModeleImpressionDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const P_MODELE_IMPRESSION_SCHEMA: RxJsonSchema<RxPModeleImpressionDocumentType> = P_MODELE_IMPRESSION_SCHEMA_LITERAL;
